import { EnggAction } from "../@types/enums";
import axios from "../helpers/bearerAxios";
import { logger } from "./loggingService";

export const getEngineeringData = async (payload: any, action: EnggAction) => {
  return await axios
    .post(
      `${import.meta.env.VITE_BASE_URL}${import.meta.env.VITE_ENGG_LETTER_URL}${action}`,payload
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      logger.error(error);
      return error;
    });
};

export const downloadEngineeringData = async (payload: any, onProgress: any) => {
  return await axios
    .post(
      `${import.meta.env.VITE_BASE_URL}${import.meta.env.VITE_ENGG_LETTER_DOWNLOAD_URL}`, payload,
      {
        responseType: 'blob',
        onDownloadProgress: ({ total, loaded }: any) => {
          const percentCompleted = Math.round((loaded * 100) / total);
          onProgress?.(percentCompleted);
        }
      }
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      logger.error(error);
      return error;
    });
};

export const updateEngineeringData = async (payload: any) => {
  return await axios
    .post(
      `${import.meta.env.VITE_BASE_URL}${import.meta.env.VITE_ENGG_LETTER_UPDATE_URL}`,payload
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      logger.error(error);
      return error;
    });
};
